
















































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import SlideBar from './SlideBar.vue'
import { ROUTER_NAME } from '../../router'
import { map } from 'lodash'
import Exam from '../../models/exam'
import UserExam from '../../models/user_exam'
import Question, { GroupQuestion } from '../../../api/v2/models/question'
import Assessment from '../../models/assessment'
import Skill from '../../models/skill'
import SkillItem from '../../models/skill_item'
import { LETTER_FORMAT } from '../../utils/constants'
import { ExamQScoreHistory } from '../../../api/v2/models/q_score_history'

@Component({
  components: {
    SlideBar
  }
})
export default class ExamResultQuestionGroupList extends Vue {
  @Prop({ required: true }) item: GroupQuestion
  @Prop({ default: false }) padding: boolean
  @Prop({ default: null }) selected: number
  @Prop({ required: true }) questionNumber: number
  @Prop({ required: true })
  exam!: Exam

  @Prop({ required: true })
  userExam!: UserExam

  @Prop({ default: null })
  examQScoreHistory!: ExamQScoreHistory | null

  get qScoreHistorySummary() {
    if (!this.examQScoreHistory) {
      return null
    }

    return this.examQScoreHistory.getQScoreHistorySummary(this.currentQuestion.id)
  }

  get groupScoreHistorySummary() {
    if (!this.examQScoreHistory) {
      return null
    }

    const groupSummaries = this.item.questions.map((q) => this.examQScoreHistory!.getQScoreHistorySummary(q.id))
    let totalCount = 0
    let successCount = 0

    groupSummaries.forEach((groupSummary) => {
      if (!groupSummary) {
        return
      }
      totalCount += groupSummary.totalCount
      successCount += groupSummary.successCount
    })

    if (!totalCount) {
      return null
    }

    return {
      totalCount,
      successCount,
      rate: Math.round((successCount / totalCount) * 100)
    }
  }

  newClass = 'question-report'

  @Watch('selected')
  onRouteChanged() {
    this.newClass = 'question-report'
    if (this.item.questions.find((question) => question.id == this.selected)) {
      this.newClass += ' selected-tab'
    }
    if (this.padding) {
      this.newClass += ' p-2'
    }
  }

  get questionCount() {
    return this.item.questions.length
  }

  get title() {
    if (this.currentQuestion.isDescriptionQuestion) {
      return this.$t('question.description', { format: LETTER_FORMAT.UPTITLECASE })
    }

    return `${this.$t('question.problem')} ${this.questionNumber}`
  }

  get currentQuestion(): Question {
    return this.item.questions[0]
  }

  get assessments(): Assessment[] {
    return this.item.getAssessmentsByUserExam(this.userExam)
  }

  get correctCount(): number {
    return this.item.getCorrectCountByUserExam(this.userExam)
  }

  get skills(): Skill[] {
    return this.item.skills
  }

  get skillsName(): string {
    return this.getSkillsName(this.skills)
  }

  get skillItems(): SkillItem[] {
    return this.item.skillItems
  }

  skillItemsName(skill: Skill): string {
    const skillItems = skill.skillItems.filter((skillItem) => this.skillItems.some((item) => item.id == skillItem.id))
    return this.getSkillsName(skillItems)
  }

  get maxScore(): number {
    return this.item.questions.reduce((a, b) => a + b.maxScore, 0)
  }

  get score(): number {
    return this.item.questions.reduce((a, b) => a + b.userScore, 0)
  }

  get isPass() {
    if (this.exam.autoDiagnosisEnabled) { return false }
    return this.score === this.maxScore
  }

  get isNotFullScore() {
    if (this.exam.autoDiagnosisEnabled) { return false }
    return this.score < this.maxScore && this.score > 0
  }

  get isNotPass() {
    if (this.exam.autoDiagnosisEnabled) { return false }
    return this.score === 0
  }

  mounted() {
    this.onRouteChanged()
  }

  showDetail() {
    this.$router.push({
      name: ROUTER_NAME.ANSWER_RESULT_DETAIL,
      params: {
        examId: this.exam.id.toString(),
        questionId: this.item.questions[0].id.toString()
      },
      query: this.$route.query
    })
  }

  getSkillsName(skills: Skill[] | SkillItem[]) {
    return map(skills, 'name').join(', ')
  }
}
